
import ReactHabitat from "react-habitat";

class Root extends ReactHabitat.Bootstrapper {
	constructor() {
		super();
		window.updateHabitat = this.update.bind(this);
		const builder = new ReactHabitat.ContainerBuilder();
		builder.registerAsync(() => import("./pages/home/home.component")).as("TreHomeWidget");
		// Finally, set the container:
		this.setContainer(builder.build());
	}
}

const root = new Root();
export default root;